import React, { useEffect, useState } from "react";
import "./GalleryPage.css";

const GALLERY_API_URL =
  "https://backend.tarsariyaparivar.in/api/v1/homephotos/gallery";

const fallbackImages = Array.from({ length: 16 }, (_, index) => ({
  id: index + 1,
  url: `https://picsum.photos/seed/tarsara-${index + 1}/1200/800`,
  thumbnail: `https://picsum.photos/seed/tarsara-${index + 1}/300/220`,
  title: `Gallery Image ${index + 1}`,
}));

const normalizeImages = (payload) => {
  const rawImages = Array.isArray(payload?.data) ? payload.data : [];

  return rawImages
    .map((item, index) => {
      const url = item?.fullPath;

      if (!url) {
        return null;
      }

      return {
        id: item.id ?? index + 1,
        url,
        thumbnail: url,
        title: item.fileName || `Gallery Image ${index + 1}`,
      };
    })
    .filter(Boolean);
};

function GalleryPage() {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    const loadImages = async () => {
      try {
        setLoading(true);
        const response = await fetch(GALLERY_API_URL, {
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("API response was not successful.");
        }

        const data = await response.json();
        const apiImages = normalizeImages(data).slice(0, 16);
        const galleryImages = apiImages.length ? apiImages : fallbackImages;

        setImages(galleryImages);
        setSelectedImage(galleryImages[0] || null);

        if (!apiImages.length) {
          setMessage("ગેલેરી માટે હાલમાં કોઈ ફોટા ઉપલબ્ધ નથી.");
        } else {
          setMessage("");
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          setImages(fallbackImages);
          setSelectedImage(fallbackImages[0]);
          setMessage("API કનેક્શન ઉપલબ્ધ ન હોવાથી ડેમો ગેલેરી દેખાય છે.");
        }
      } finally {
        setLoading(false);
      }
    };

    loadImages();

    return () => controller.abort();
  }, []);

  return (
    <div className="gallery-page">
      <section className="container gallery-section">
        <h2>ગેલેરી</h2>
        {console.log(message)}
        {message && <p className="gallery-message">{message}</p>}

        <div className="gallery-preview-card">
          {selectedImage ? (
            <>
              <div className="gallery-preview-frame">
                <img src={selectedImage.url} alt={selectedImage.title} />
              </div>
              {/* <h3>{selectedImage.title}</h3> */}
            </>
          ) : (
            <div className="gallery-empty-state">ઈમેજ લોડ થઈ રહી છે...</div>
          )}
        </div>

        {loading ? (
          <p className="gallery-status">ઈમેજ લોડ થઈ રહી છે...</p>
        ) : (
          <div className="gallery-grid">
            {images.map((image) => (
              <button
                key={image.id}
                type="button"
                className={`gallery-thumb ${
                  selectedImage?.id === image.id ? "active" : ""
                }`}
                onClick={() => setSelectedImage(image)}
              >
                <img src={image.thumbnail} alt={image.title} />
              </button>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default GalleryPage;
